module.exports = __webpack_public_path__ + "img/open-Indicator-select.1235e4a3.svg";